<div class="reminder-control" *ngIf="DisplayMode==1">
  <input type="text" (focus)="showReminderbox()" [disabled]="isDisabled" />
  <button mat-mini-fab color="accent" (click)="showReminderbox()" aria-label="New Reminder">
    <mat-icon>add</mat-icon>
  </button>
  <form class="data-form">
    <ngx-smart-modal #modal identifier="myModal" customClass="'modal'">
      <h4 class="modal-title">{{modalTitle}}</h4>
      <input type="text" placeholder="{{placeholderText}}">
    </ngx-smart-modal>
  </form>
</div>
<div class="reminder-control" *ngIf="DisplayMode==2">

</div>
<div class="reminder-control" *ngIf="DisplayMode==3">
  <div *ngIf="CompactView">
    <mat-form-field class="form-element w-100">
      <mat-label>{{selectedData.ReminderDateTime?.toLocaleDateString('en-GB') }}</mat-label>
      <input matInput [placeholder]="placeholderText" [disabled]="(selectedData.IsCompleted && !ForceEnable) || isDisabled" [(ngModel)]="selectedData.ReminderDetails" />
    </mat-form-field>
  </div>
  <div *ngIf="!CompactView">
    <mat-form-field class="form-element w-100 line-1">
      <mat-label>{{selectedData.ReminderDateTime?.toLocaleDateString('en-GB') }}</mat-label>
      <textarea matInput [placeholder]="placeholderText" [disabled]="(selectedData.IsCompleted && !ForceEnable) || isDisabled" [(ngModel)]="selectedData.ReminderDetails"></textarea>
    </mat-form-field>
  </div>

</div>
<div class="reminder-control" *ngIf="DisplayMode==4">
  <table>
    <tr>
      <td>
        <div class="form-element textfield-mr2">
          <mat-checkbox [(ngModel)]="selectedData.IsCompleted"></mat-checkbox>
        </div>
      </td>
      <td>
        <mat-form-field class="form-element field-l textfield-mr2">
          <input matInput [placeholder]="placeholderText" [disabled]="selectedData.IsCompleted && !ForceEnable" (focus)="reminderDatePicker.open()" [matDatepicker]="reminderDatePicker" [(ngModel)]="selectedData.ReminderDateTime">
          <mat-datepicker-toggle matSuffix [for]="reminderDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #reminderDatePicker></mat-datepicker>
        </mat-form-field>
      </td>
      <td>
        <!--<span class="fieldvalue"> {{selectedData.ReminderDetails}} </span>
        <input class="fieldvalue" type="text" placeholder="{{placeholderText}}" value="" />-->

        <mat-form-field class="form-element field-xl textfield-mr2">
          <input matInput placeholder="Remarks" [(ngModel)]="selectedData.ReminderDetails">
        </mat-form-field>
      </td>

    </tr>
  </table>
</div>
<div class="reminder-control" *ngIf="DisplayMode==5">
  <table>
    <tr>
      <td>
        <mat-form-field class="form-element w-100">
          <input matInput [placeholder]="placeholderText" [disabled]="selectedData.IsCompleted && !ForceEnable" (focus)="reminderDatePicker.open()" [matDatepicker]="reminderDatePicker" [(ngModel)]="selectedData.ReminderDateTime">
          <mat-datepicker-toggle matSuffix [for]="reminderDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #reminderDatePicker></mat-datepicker>
        </mat-form-field>
      </td>
      <td>
        <mat-checkbox [(ngModel)]="selectedData.IsCompleted"></mat-checkbox>
      </td>
    </tr>
  </table>
</div>
<div class="reminder-control" *ngIf="DisplayMode==6">
  <div *ngIf="CompactView">
    <table class="w-100" >
      <tr>
        <td>
          <mat-form-field class="form-element w-100 fnt-08">
            <mat-label>{{selectedData.ReminderDateTime?.toLocaleDateString('en-GB') }}</mat-label>
            <input matInput [placeholder]="placeholderText" [disabled]="selectedData.IsCompleted && !ForceEnable" [(ngModel)]="selectedData.ReminderDetails">
          </mat-form-field>
        </td>
        <td style="width:125px;">
          <!--Reminder Sub-Type-->
          <mat-form-field class="form-element w-100 fnt-08 padding-ls">
            <mat-select [disabled]="DisableSubType" [placeholder]="SubTypeLabel" [compareWith]="compareObjects" [(ngModel)]="selectedData.ReminderSubType">
              <mat-option *ngFor="let stype of SubTypeList" [value]="stype">
                {{stype.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </td>
        <td style="width:85px;">
          <!--Reminder Response Type-->
          <mat-form-field class="form-element w-100 fnt-08 padding-ls">
            <mat-select [disabled]="DisableResponseType" [placeholder]="ResponseTypeLabel" [compareWith]="compareObjects" [(ngModel)]="selectedData.ReminderResponseType">
              <mat-option *ngFor="let rtype of ResponseTypeList" [value]="rtype">
                {{rtype.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </td>
      </tr>
    </table>
  </div>
  <div *ngIf="!CompactView">
    <table>
      <tr>
        <td>
          <div class="form-element textfield-mr2">
            <mat-checkbox [(ngModel)]="selectedData.IsCompleted"></mat-checkbox>
          </div>
        </td>
        <td>
          <mat-form-field class="form-element field-l textfield-mr2">
            <input matInput [placeholder]="placeholderText" [disabled]="selectedData.IsCompleted && !ForceEnable" (focus)="reminderDatePicker.open()" [matDatepicker]="reminderDatePicker" [(ngModel)]="selectedData.ReminderDateTime">
            <mat-datepicker-toggle matSuffix [for]="reminderDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #reminderDatePicker></mat-datepicker>
          </mat-form-field>
        </td>
        <td>
          <!--Reminder Sub-Type-->
          <mat-form-field class="form-element field-l textfield-mr2">
            <mat-select [disabled]="DisableSubType" [placeholder]="SubTypeLabel" [compareWith]="compareObjects" [(ngModel)]="selectedData.ReminderSubType">
              <mat-option *ngFor="let stype of SubTypeList" [value]="stype">
                {{stype.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </td>
        <td>
          <!--Reminder Response Type-->
          <mat-form-field class="form-element field-l textfield-mr2">
            <mat-select [disabled]="DisableResponseType" [placeholder]="ResponseTypeLabel" [compareWith]="compareObjects" [(ngModel)]="selectedData.ReminderResponseType">
              <mat-option *ngFor="let rtype of ResponseTypeList" [value]="rtype">
                {{rtype.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </td>
        <td>
          <!--<span class="fieldvalue"> {{selectedData.ReminderDetails}} </span>
          <input class="fieldvalue" type="text" placeholder="{{placeholderText}}" value="" />-->

          <mat-form-field class="form-element field-xl textfield-mr2">
            <input matInput placeholder="Remarks" [(ngModel)]="selectedData.ReminderDetails">
          </mat-form-field>
        </td>
      </tr>
    </table>
  </div>

</div>
